import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BadgeCheckIcon, InfoIcon } from 'lucide-react';
import { PageHero } from './PageHero';
import { CtaBand } from './CtaBand';
import { company, decennale, services, type Service } from '../data/site';
type ServicePageProps = {
  service: Service;
  note?: string;
  children?: React.ReactNode;
};
export function ServicePage({
  service,
  note,
  children
}: ServicePageProps) {
  const otherServices = services.filter(s => s.key !== service.key);
  return <>
      <PageHero eyebrow={service.shortLabel} title={service.label} text={service.summary} image={service.image} imageAlt={service.imageAlt} data-id="element-128" data-mp="qrxr7ughvjtx" />

      <section className="bg-white" data-id="element-129" data-mp="gzs0sp5w5agu">
        <div className="mx-auto max-w-content px-5 py-14 lg:px-8 lg:py-20" data-id="element-130" data-mp="gyqokhd52hxj">
          <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-131" data-mp="1eh0f3k1q28wv">
            <div className="lg:col-span-7" data-id="element-132" data-mp="19oywzhhvhnyx">
              <h2 className="font-display text-[1.6rem] font-extrabold leading-tight tracking-tight text-navy-800 sm:text-3xl" data-id="element-133" data-mp="19o7bx0lwj8mw">
                Les prestations réalisées
              </h2>
              <ul className="mt-7 divide-y divide-line border-y border-line" data-id="element-134" data-mp="38l5coqib14zy">
                {service.bullets.map(b => <li key={b} className="flex gap-4 py-4" data-id="element-135" data-mp="2usfp4hn4ns0q">
                    <BadgeCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ember-500" aria-hidden="true" data-id="element-136" data-mp="2yuj25apg34o4" />
                    <p className="text-[1.02rem] leading-relaxed text-navy-600" data-id="element-137" data-mp="2pvozb2liti24">
                      {b}
                    </p>
                  </li>)}
              </ul>

              {note && <div className="mt-8 flex gap-4 rounded-2xl bg-navy-50 p-5 sm:p-6" data-id="element-138" data-mp="2fy130889o2hu">
                  <InfoIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-500" aria-hidden="true" data-id="element-139" data-mp="a3htefyu4bhf" />
                  <p className="text-[0.98rem] leading-relaxed text-navy-600" data-id="element-140" data-mp="e3ij4wrdw93s">
                    {note}
                  </p>
                </div>}

              {children}
            </div>

            <aside className="lg:col-span-5" data-id="element-141" data-mp="1i5tbmdh2mcdt">
              <div className="rounded-2xl border border-line bg-surface p-6 shadow-card sm:p-7" data-id="element-142" data-mp="1e2wms50xtk1f">
                <h2 className="font-display text-xl font-extrabold text-navy-800" data-id="element-143" data-mp="193tvdndvrcbx">
                  Besoin d'un devis ?
                </h2>
                <p className="mt-3 text-[0.97rem] leading-relaxed text-navy-500" data-id="element-144" data-mp="25v5gj15d7yab">
                  {company.devisNote}. Expliquez votre besoin par téléphone ou via
                  le formulaire, vous serez orienté vers la solution la plus
                  adaptée.
                </p>
                <a href={company.phoneHref} className="mt-6 block whitespace-nowrap rounded-xl bg-ember-500 px-5 py-4 text-center font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-ember-600" data-id="element-145" data-mp="1s1ea41mxkuit">
                  {company.phone}
                </a>
                <Link to="/contact" className="mt-3 block rounded-xl bg-navy-800 px-5 py-4 text-center font-display font-bold text-white transition-colors duration-150 ease-out hover:bg-navy-700" data-id="element-146" data-mp="2x0b2gxx4q4oz">
                  Demander un devis
                </Link>
                <p className="mt-5 border-t border-line pt-5 text-sm leading-relaxed text-navy-500" data-id="element-147" data-mp="3b0uba79f5es7">
                  {decennale}
                </p>
              </div>

              <nav className="mt-8" aria-label="Autres prestations" data-id="element-148" data-mp="3fx2nbbsbkrv5">
                <h2 className="font-display text-sm font-bold uppercase tracking-[0.16em] text-ember-500" data-id="element-149" data-mp="3kqxcuvulw125">
                  Autres prestations
                </h2>
                <ul className="mt-4 space-y-3" data-id="element-150" data-mp="3trlhizy40p2d">
                  {otherServices.map(s => <li key={s.key} data-id="element-151" data-mp="2jr59rmaw3g4">
                      <Link to={s.path} className="flex items-center justify-between gap-4 rounded-xl border border-line bg-white px-5 py-4 font-display font-bold text-navy-700 transition-colors duration-150 ease-out hover:border-navy-200 hover:text-ember-500" data-id="element-152" data-mp="2ksgpx78aryd">
                        {s.label}
                        <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-153" data-mp="3puxt7yk3pnnk" />
                      </Link>
                    </li>)}
                </ul>
              </nav>
            </aside>
          </div>
        </div>
      </section>

      <CtaBand data-id="element-154" data-mp="3c0exg5ynxie8" />
    </>;
}